import { ContractsListByAccountIdSuccessListResponse } from '@genial/services';
import { BeneficiariesRequest, ResponsesKinshipConfigResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { BeneficiariesFormData } from '../../../pages/CustomerDetail/components/PrivatePensionContacted/components/ChangeBeneficiaries/constants';

import {
  CustomerPrivatePensionContractedNormalized,
  PrivatePensionCompanyConfigProps,
} from './types';

export const normalizeCustomerPrivatePensionContracted = (
  data: ContractsListByAccountIdSuccessListResponse['data']
): CustomerPrivatePensionContractedNormalized[] => {
  if (!data) {
    return [];
  }

  return data.map((privatePension) => ({
    insuranceProposalId: privatePension.insuranceProposalId || 0,
    certificate: privatePension.certificateId?.toString() || '--',
    insurer: privatePension.insuranceCompanyName || '--',
    fund: privatePension.fundName || '--',
    positionDate: privatePension.positionDate
      ? Utils.Mask.DateFormat(privatePension.positionDate, 'dd/MM/yyyy')
      : '--',
    planType: privatePension.planType || '--',
    taxRegime: privatePension.taxRegime || '--',
    dayPercentage: Utils.Mask.Percentage(privatePension.dailyValue),
    monthPercentage: Utils.Mask.Percentage(privatePension.monthlyValue),
    yearPercentage: Utils.Mask.Percentage(privatePension.yearlyValue),
    currentQuota: Utils.Mask.Money(privatePension.currentQuotaValue),
    grossValue: Utils.Mask.Money(privatePension.grossValue),
    certificateStatus: privatePension.certificateStatus || '--',
  }));
};

export const normalizeCustomerPrivatePensionBeneficiaries = (
  beneficiaries: BeneficiariesRequest[] | null | undefined
): BeneficiariesFormData['beneficiaries'] => {
  if (!beneficiaries) {
    return [];
  }

  return beneficiaries.map((beneficiary) => ({
    name: beneficiary.beneficiaryName || '',
    relationship: beneficiary.relationshipId.toString(),
    birthDate: beneficiary.birthDate,
    participation: Utils.Mask.InputPercentage(beneficiary.percentage),
  }));
};

export const normalizePrivatePensionCompanyConfig = (
  data: ResponsesKinshipConfigResponse
): PrivatePensionCompanyConfigProps => {
  if (!data || !data.kinships) {
    return { beneficiariesLimit: 10, beneficiariesRelationship: [] };
  }

  return {
    beneficiariesLimit: data.beneficiaryLimit,
    beneficiariesRelationship: data.kinships.map((kinship) => ({
      label: kinship.kinshipDescription || '',
      value: kinship.kinshipId.toString(),
    })),
  };
};
